/* eslint-disable no-param-reassign */
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Callback para logout customizado
let onUnauthorized = null;

export const setUnauthorizedCallback = (callback) => {
  onUnauthorized = callback;
};

api.interceptors.request.use((config) => {
  const storedUser = localStorage.getItem(
    process.env.REACT_APP_LOCAL_STORAGE_USER_KEY
  );
  if (storedUser) {
    const parsed = JSON.parse(storedUser);
    if (parsed?.token) {
      config.headers.Authorization = `Bearer ${parsed.token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRoute =
      error.config?.url?.includes('/sign-in') ||
      error.config?.url?.includes('/login');

    if (error.response?.status === 401 && !isLoginRoute) {
      console.log('🔒 Token inválido/expirado');
      localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_USER_KEY);

      // ✅ Usa callback se existir, senão usa window.location
      if (onUnauthorized) {
        onUnauthorized();
      } else {
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
